// Ignora mayúsculas y tildes
export const normalizeText = (text) => {
  return text ? text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : ''
}

// Filtro personalizado para buscar en los nombres ignorando mayúsculas y tildes
export const customFilter = (queryText, itemText) => {
  if (itemText) {
    const text = normalizeText(itemText)
    const query = normalizeText(queryText)
    return text.includes(query)
  } else {
    return false
  }
}

// Contar elementos filtrados
export function countFilteredItems(items, filterFn) {
  return items.filter(filterFn).length
}

// Limpiar filtros
export const clearFilters = (filters) => {
  for (const key in filters) {
    if (Object.prototype.hasOwnProperty.call(filters, key)) {
      filters[key] = null // O valor inicial
    }
  }
}

/**
 * Sanitiza un nombre de archivo válido en Windows/macOS/Linux.
 *  - Quita acentos (NFD + elimina marcas combinantes).
 *  - Sustituye cualquier carácter fuera de [A-Za-z0-9._-] por "_".
 *  - Colapsa múltiples "_" en uno solo y elimina "_" al inicio/fin.
 *  - Quita puntos/espacios al final (inválidos en Windows).
 *  - Evita nombres reservados de Windows (CON, PRN, AUX, NUL, COM1–9, LPT1–9) anteponiendo "_".
 *  - Si queda vacío, devuelve "untitled".
 *  - Limita la longitud a 255 caracteres.
 */
export const sanitizeFileName = (str) => {
  let s = String(str)
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9._-]+/g, '_')
    .replace(/\.(?![A-Za-z]{1,10}$)/g, '_') // quita todos los puntos salvo el de la extensión (letras)
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/[.\s]+$/g, '');

  const base = s.replace(/\.[A-Za-z]{1,10}$/, '');
  if (/^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/i.test(base)) s = `_${s}`;

  return (s || 'untitled').slice(0, 255);
};

export const handleBlobDownload = (data, headers, nombreSim, fecha) => {
  const contentType = headers['content-type'] || 'application/octet-stream'
  const contentDisposition = headers['content-disposition']

  let backendFileName = 'simulacion.zip'

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="(.+)"/)
    if (match?.[1]) {
      backendFileName = match[1]
    }
  }

  const finalFileName = `Simulacion_${nombreSim}_${fecha}_${backendFileName}`

  const blob = new Blob([data], { type: contentType })
  const downloadUrl = window.URL.createObjectURL(blob)

  const element = document.createElement('a')
  element.href = downloadUrl
  element.download = finalFileName

  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)

  URL.revokeObjectURL(downloadUrl)
}

export const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  const finalFileName = sanitizeFileName(fileName)

  link.href = url
  link.download = finalFileName
  document.body.appendChild(link)

  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
